module.exports = new __parcel__URL__("logo_ports_loire_atlantique.7fde878d.png").toString();